import styled from 'styled-components'
import { LookButton, iconButtonLook } from 'components/Buttons/look'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  background-color: ${({ editting }) => editting ? '#F7F7F7' : '#FFFFFF'};
  width: 100%;
  min-height: 46px;
  margin: 0px 0px 10px;
  padding: 0px 12px;
  box-shadow: 0px 2px 10px -6px #252525;
  text-decoration: none;
  border-radius: 15px;
  display: grid;
  grid-template-columns: ${({ editting, cutileiSchedule, enableEditting }) => (
    editting
      ? '2fr 2fr repeat(5, 1fr)'
      : `repeat(${cutileiSchedule || !enableEditting ? 4 : 5}, 1fr) minmax(140px, auto) 1fr`
  )};
  gap: 10px;
  justify-content: center;
  align-items: center;
  justify-items: center;

  &:hover {
    background-color: #F7F7F7;
  }
`

export const FormField = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  margin: 0px;
`

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
`

export const CheckRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 0px;
  gap: 3px;

  label, p {
    cursor: pointer;
    margin-bottom: 1px;
  }
`

export const Image = styled.img`  
  width: 16px;
  height: 16px;
`

export const Label = styled.label`
  font-size: 12px;
  text-align: center;
  color: #000000;
  margin: 0px;

  &:hover {
    cursor: pointer;
  }
`

export const TooltipLabel = styled(Label)`
  color: #FFFFFF;
  width: 265px;
`

export const InfoText = styled.p`
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #000000;
  margin: 0px;
`

export const SubTitle = styled(InfoText)`
  font-weight: bold;
  text-align: left;
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0px;
  padding: 0px;
`

export const Button = styled(LookButton).attrs({ type: 'button' }).attrs(iconButtonLook())`
  width: 32px;
  height: 32px;
`
